// 메뉴 검색용 한글 초성 매칭 헬퍼 (순수 함수, UI 의존성 없음).
//
// "ㅅㄱㄱㅅㅅ" 처럼 초성만 입력해도 "세금계산서" 를 찾을 수 있게 한다.
// 완성형 한글 음절(가~힣)은 코드포인트가 (초성*21 + 중성)*28 + 종성 + 0xAC00 규칙이라,
// 초성 인덱스 = Math.floor((code - 0xAC00) / (21*28)) 로 바로 구할 수 있다.

// 완성형 한글의 초성 19개(유니코드 순서 그대로).
const CHOSUNG_LIST = [
  'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ',
  'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ',
];
const HANGUL_BASE = 0xac00;
const HANGUL_LAST = 0xd7a3;
const CHOSUNG_UNIT = 21 * 28; // 한 초성 블록에 포함되는 음절 수

/**
 * 문자열을 "초성 문자열"로 바꾼다. 완성형 한글 음절은 초성 한 글자로, 그 외(공백/영문/숫자 등)는
 * 그대로 둔다. 길이가 원본과 항상 같아서(1글자 -> 1글자) 매칭된 위치를 원본 인덱스로 그대로 쓸 수 있다.
 */
export const toChosung = (str) => {
  if (!str) return '';
  let result = '';
  for (const ch of str) {
    const code = ch.codePointAt(0);
    if (code >= HANGUL_BASE && code <= HANGUL_LAST) {
      const chosungIndex = Math.floor((code - HANGUL_BASE) / CHOSUNG_UNIT);
      result += CHOSUNG_LIST[chosungIndex];
    } else {
      result += ch;
    }
  }
  return result;
};

/** query 가 초성 자모로만 이루어져 있는지(공백 제외). 하나라도 아니면 초성 검색을 시도하지 않는다. */
export const isChosungOnly = (query) => {
  if (!query) return false;
  const chars = [...query].filter((ch) => ch !== ' ');
  if (chars.length === 0) return false;
  return chars.every((ch) => CHOSUNG_LIST.includes(ch));
};

/**
 * target 문자열에서 query 가 매치되는 구간을 찾는다.
 * 1) 먼저 대소문자 구분 없는 일반 부분 문자열 매칭을 시도하고,
 * 2) query 가 초성뿐이면 초성 문자열로도 매칭을 시도한다.
 * 매치된 부분은 원본 target 기준 { index, length } 로 돌려준다(하이라이트용). 없으면 null.
 */
export const matchMenuText = (target, query) => {
  if (!target || !query) return null;

  const idx = target.toLowerCase().indexOf(query.toLowerCase());
  if (idx !== -1) {
    return { index: idx, length: query.length };
  }

  if (isChosungOnly(query)) {
    const chosungTarget = toChosung(target);
    const chosungIdx = chosungTarget.indexOf(query);
    if (chosungIdx !== -1) {
      return { index: chosungIdx, length: query.length };
    }
  }

  return null;
};
